import { useQuery } from "@tanstack/react-query";
import { Fragment, useMemo } from "react";
import Swal from "sweetalert2";
import Laoding from "../../components/Loading";
import { postMethod } from "../../function/helper";
import useFilters from "../../hooks/useFilters";
import Footer from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import PayLinkCheckoutButton from "./components/PayLinkCheckoutButton";
import PayLinkCheckoutCard from "./components/PayLinkCheckoutCard";

export default function PayLinkPage() {
  const filters = useFilters();

  const numberParcels = useMemo(() => {
    const ids = filters.get("id");
    if (!ids) {
      return [];
    }
    const array = ids.split("_");
    if (!Array.isArray(array) || array.length < 1) {
      return [];
    }
    return array;
  }, []);

  const { isFetching, data } = useQuery({
    queryKey: ["PayLinkPage"],
    queryFn: () =>
      postMethod("/totalpost/v1/payLink/checkout", {
        numberParcels,
      }).then(res => {
        if (res && res.status === 200) {
          return res.data.data;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
        return [];
      }),

    placeholderData: [],
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 rtl-all container py-5">
        <h4 className="mb-0">پرداخت سفارشات</h4>

        {isFetching && <Laoding />}

        {!isFetching && data.length === 0 && (
          <h5 className="text-danger">شماره سفارش انتخاب شده نامعتبر است.</h5>
        )}

        {!isFetching && data.length > 0 && (
          <Fragment>
            <PayLinkCheckoutCard orders={data} />
            <PayLinkCheckoutButton orders={data} />
          </Fragment>
        )}
      </main>
      <Footer />
    </Fragment>
  );
}
